
// @ts-nocheck


export const localeCodes =  [
  "de",
  "fr",
  "it",
  "en"
]

export const localeLoaders = {
  "de": [{ key: "../lang/cms.ts", load: () => import("../lang/cms.ts?hash=f25a17f5&locale=de" /* webpackChunkName: "locale__vercel_path0_lang_cms_ts" */), cache: false }],
  "fr": [{ key: "../lang/cms.ts", load: () => import("../lang/cms.ts?hash=f25a17f5&locale=de" /* webpackChunkName: "locale__vercel_path0_lang_cms_ts" */), cache: false }],
  "it": [{ key: "../lang/cms.ts", load: () => import("../lang/cms.ts?hash=f25a17f5&locale=de" /* webpackChunkName: "locale__vercel_path0_lang_cms_ts" */), cache: false }],
  "en": [{ key: "../lang/cms.ts", load: () => import("../lang/cms.ts?hash=f25a17f5&locale=de" /* webpackChunkName: "locale__vercel_path0_lang_cms_ts" */), cache: false }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "de",
      "name": "Deutsch",
      "iso": "de-CH",
      "languageId": "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
      "files": [
        "lang/cms.ts"
      ]
    },
    {
      "code": "fr",
      "name": "Français",
      "iso": "fr-CH",
      "languageId": "018ec22cafd07c88ad2cc57c35e6ef97",
      "files": [
        "lang/cms.ts"
      ]
    },
    {
      "code": "it",
      "name": "Italiano",
      "iso": "it-CH",
      "languageId": "018ec22d098f7aaeb8a0dcf6a7854ffa",
      "files": [
        "lang/cms.ts"
      ]
    },
    {
      "code": "en",
      "name": "English",
      "iso": "en-GB",
      "languageId": "018d318cc19370c7b43bc8cc79583e76",
      "files": [
        "lang/cms.ts"
      ]
    }
  ],
  "defaultLocale": "de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "lang/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "de",
    "name": "Deutsch",
    "iso": "de-CH",
    "languageId": "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
    "files": [
      {
        "path": "lang/cms.ts"
      }
    ]
  },
  {
    "code": "fr",
    "name": "Français",
    "iso": "fr-CH",
    "languageId": "018ec22cafd07c88ad2cc57c35e6ef97",
    "files": [
      {
        "path": "lang/cms.ts"
      }
    ]
  },
  {
    "code": "it",
    "name": "Italiano",
    "iso": "it-CH",
    "languageId": "018ec22d098f7aaeb8a0dcf6a7854ffa",
    "files": [
      {
        "path": "lang/cms.ts"
      }
    ]
  },
  {
    "code": "en",
    "name": "English",
    "iso": "en-GB",
    "languageId": "018d318cc19370c7b43bc8cc79583e76",
    "files": [
      {
        "path": "lang/cms.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
